import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { UserHttpClient } from './user-http-client';
import { UserActions } from './user.store';

@Injectable({ providedIn: 'root' })
export class UserEffects {
  public effects = createEffectFactory(UserActions, this.actions$);

  public fetchCollection$$ = this.effects(UserActions.fetchCollection, () =>
    this.userService.fetchCollection().pipe(map(data => ({ data }))),
  );

  constructor(private userService: UserHttpClient, private actions$: Actions) {}
}
